"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Utils = require("./helpers/Utils.js");

var _styled = require("./styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CellImage = function CellImage(props) {
  var data = props.data,
      header = props.header,
      headerText = props.headerText,
      handleClick = props.handleClick,
      highlighted = props.highlighted,
      width = props.width,
      sortable = props.sortable,
      sortOrder = props.sortOrder,
      sorted = props.sorted;

  if (!header && !(0, _Utils.validateString)(data)) {
    return /*#__PURE__*/_react["default"].createElement(_styled.StyledCell, {
      width: width
    }, "-");
  }

  var justin = "https://www.etonline.com/sites/default/files/styles/max_970x546/public" + "/images/2019-12/bette_midler_justin_gettyimages-2pics_1280.jpg?itok=r26sEhCD&h=c673cd1c";
  return header ? /*#__PURE__*/_react["default"].createElement(_styled.StyledHeaderCell, {
    onClick: handleClick,
    width: width,
    sortable: sortable,
    sortOrder: sortOrder,
    sorted: sorted
  }, headerText) : /*#__PURE__*/_react["default"].createElement(_styled.StyledCell, {
    padding: "0",
    highlited: highlighted,
    width: width,
    height: "100%",
    sorted: sorted
  }, /*#__PURE__*/_react["default"].createElement(_styled.StyledCellImage, {
    url: justin
  }), /*#__PURE__*/_react["default"].createElement(_styled.StyledCellTextContainer, null, data));
};

var _default = CellImage;
exports["default"] = _default;

//# sourceMappingURL=CellImage.js.map